import type { IFieldOptions } from '@axo/form/feature/form-input/types';
import { loan_application } from '@axo/shared/data-access/types';

export const initialPurposeFieldOptions = {
  registerOptions: { required: 'error.required' },
  tooltipValidation: {
    ignoreFocus: true,
    message: (value) => {
      if (value === loan_application.Purpose.Other) {
        return 'InitialPurpose.warning';
      }
      if (value === loan_application.Purpose.RefinancingLoan) {
        return 'InitialPurpose.refinancing';
      }
    },
  },
} satisfies IFieldOptions;
